/**
 * @file コンポーネント：ノートドロワー DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Note } from "~/src/components/projects/Note";

// 関数読み込み
import { fnIsTouchDevice } from "~/src/functions/boolean";

// スタイル読み込み
import {
    StyledDrawer,
    StyledDrawerClose,
    StyledDrawerHeader,
    StyledDrawerNote,
    StyledDrawerTitle,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledDrawer
            className={props.isOpenDrawerNote === true && "is-open"}
            ref={props.refDrawer}
        >
            {/* ヘッダー（高さ調整のタッチ要素） */}
            {fnIsTouchDevice() === true ? (
                // タッチデバイスの場合
                <StyledDrawerHeader
                    onTouchEnd={(e) => props.fnOnTouchEnd(e)}
                    onTouchMove={(e) => props.fnOnTouchMove(e)}
                    onTouchStart={(e) => props.fnOnTouchStart(e)}
                />
            ) : (
                // 非タッチデバイスの場合
                <StyledDrawerHeader
                    className={props.isDrag === true && "is-drag"}
                    onMouseDown={(e) => props.fnOnMouseDown(e)}
                    onMouseMove={(e) => props.fnOnMouseMove(e)}
                />
            )}
            {/* 見出し（症例タイトル） */}
            <StyledDrawerTitle>{props.operationTitle}</StyledDrawerTitle>
            {/* ノート本体 */}
            <StyledDrawerNote>
                <Note
                    fnJump={props.fnJump}
                    hasAddTimeline={props.operationId !== undefined}
                    hasButtonDelete={props.hasButtonDelete}
                    isLoadingFullvideo={props.isLoadingFullvideo}
                    noteId={props.noteId}
                    operationId={props.operationId}
                    setCurrentPage={props.setCurrentPage}
                    setIsOpenDrawerNote={props.setIsOpenDrawerNote}
                    timeProgress={props.timeProgress}
                />
            </StyledDrawerNote>
            {/* 閉じるボタン */}
            <StyledDrawerClose
                onClick={() => props.setIsOpenDrawerNote(false)}
                type="button"
            >
                <i className="fas fa-times"></i>
            </StyledDrawerClose>
        </StyledDrawer>
    );
};
